<!-- <app-header></app-header> -->

<div class="page">
  <div class="makingComp1">
    <div *ngIf="parameterValue != 'individual'" class="making container">
      <div class="row row2">
        <div class="col-md-7 order-2 order-md-1 left">
          <h1>
            Making educational payments <br />
            <span class="titleAnimation"
              >one <span style="color: #5800bf">Klick</span> away.</span
            >
          </h1>

          <p class="p2">
            Klickit is a fintech company operating in the education industry. We offer a secure fees management system for educational institutions and a hassle-free payment experience for parents.
          </p>

          <div class="makingCTAs">
            <a
              class="ctaButton"
              href="https://admin.klickit.co"
              target="_blank"
            >
              Login
            </a>

            <a
              class="ctaButton4"
              href="/sales"
              target="_blank"
            >
              Contact Sales
              <span
                ><img src="../../../assets/images/chevron.right2.svg"
              /></span>
            </a>
          </div>
        </div>

        <div class="col-md-5 order-1 order-md-2 right">
          <img  id="busImg" class="busImg" src="../../../assets/images/busImg.svg" />

          <!-- <div class="images">
            <img id="making2" class="making2" src="../../../assets/images/making2.svg" />
            <img class="making1" src="../../../assets/images/making1.jpeg" />
            <img id="making3" class="making3" src="../../../assets/images/making3.svg" />
          </div> -->
        </div>
      </div>
    </div>
  </div>

  <div class="makingComp1">
    <div *ngIf="parameterValue == 'individual'" class="making container">
      <div class="row">
        <div class="col-md-7 order-2 order-md-1 left">
          <h1>
            Making educational payments <br />
            <span class="titleAnimation"
              >one <span style="color: #5800bf">Klick</span> away.
            </span>
          </h1>

          <p class="p2">
            Klickit is a fintech company operating in the education industry. We offer a secure fees management system for educational institutions and a hassle-free payment experience for parents.
          </p>

          <a class="ctaButton" href="https://pay.klickit.co/" target="_blank">
            Pay Now
          </a>
        </div>

        <div class="col-md-5 order-1 order-md-2 right">
          <div class="imageflex">
            <div >
              <swiper
                class="textComp"
                id="swiperMaking"
                style="
                  --swiper-navigation-color: rgba(0, 0, 0, 0);
                  --swiper-pagination-color: #fff;
                "
                [direction]="'vertical'"
                [mousewheel]="true"
               
                [breakpoints]="{
                  '1200': {
                    slidesPerView: 4,
                    spaceBetween: 0
                  },

                  '767': {
                    slidesPerView: 4,
                    spaceBetween: 0
                  },
                  '0': {
                    slidesPerView: 3.5,
                    spaceBetween: 10
                  }
                }"
              >
                <ng-template swiperSlide>
                  <div id="listx1" class="flexCard testClass">
                    <p>Online</p>
                    <div class="flexCardCircle"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="flexCard" id="listx2">
                    <p>Payment Networks</p>
                    <div class="flexCardCircle"></div>
                  </div>
                </ng-template>

                <ng-template swiperSlide>
                  <div class="flexCard" id="listx3">
                    <p>Wallets</p>
                    <div class="flexCardCircle"></div>
                  </div>
                </ng-template>

                <ng-template swiperSlide>
                  <div class="flexCard" id="listx4">
                    <p>POS</p>
                    <div class="flexCardCircle"></div>
                  </div>
                </ng-template>

                <ng-template swiperSlide>
                  <div class="flexCard" id="listx5">
                    <p>OTC</p>
                    <div class="flexCardCircle"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="flexCard" id="listx6">
                    <p>Bank Transfer</p>
                    <div class="flexCardCircle"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="flexCard" id="listx7">
                    <p>ATMs</p>
                    <div class="flexCardCircle"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="flexCard" id="listx8">
                    <p>COD</p>
                    <div class="flexCardCircle"></div>
                  </div>
                </ng-template>
              </swiper>
            </div>
            <img src="../../../assets/images/flexible.svg" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="parameterValue != 'individual'" class="solutions container comp">
    <div class="solutionsTitle row">
      <h4>Klickit Solutions</h4>
    </div>
    <div class="row">
      <span class="col-1"></span>
      <div class="col-10 solutionsInner">
        <div class="solutionsComp">
          <img src="../../../assets/images/solutions/sol1.svg" />
          <p class="solutionsCompTitle">Customizable Dashboard</p>
          <p class="p2">
            A platform tailored for you to track all your revenues seamlessly
            across all your streams.
          </p>
        </div>

        <div class="solutionsComp">
          <img src="../../../assets/images/solutions/sol2.svg" />
          <p class="solutionsCompTitle">Diverse Payment Methods</p>
          <p class="p2">
            Parents have full flexibility to choose their desired payment
            option.
          </p>
        </div>

        <div class="solutionsComp">
          <img src="../../../assets/images/solutions/sol3.svg" />
          <p class="solutionsCompTitle">Seamless Integration</p>
          <p class="p2">
            Our payment platform can be integrated with your website to enable
            customers to securely pay through your own system whether it’s ERP,
            CRM or other software solutions.
          </p>
        </div>

        <div class="solutionsComp">
          <img src="../../../assets/images/solutions/sol4.svg" />
          <p class="solutionsCompTitle">Real Time Insights</p>
          <p class="p2">
            Better visualize your data through our custom dashboards to help you
            measure metrics & KPIs relevant to your payment system.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="parameterValue != 'individual'" class="ready comp">
    <div class="readyImg">
      <img src="../../../assets/images/ready.svg" />
    </div>

    <div class="readyText">
      <h4 class="">Ready to boost your business to the next level?</h4>
      <a class="ctaButton5" href="/sales" target="_blank">
        Contact Sales
        <span
          ><img
            class="readyTextImg"
            src="../../../assets/images/chevron.right2.svg"
        /></span>
      </a>
    </div>
  </div>

  <!-- <div class="lineComp comp container"></div> -->

  <div *ngIf="parameterValue == 'individual'" class="howtopay container comp">
    <div class="howtopayText">
      <h4>Steps to pay</h4>
    </div>
    <!-- <div class="howtpayImage"></div> -->
    <img class="howtpayImage web" src="../../../assets/images/howtopay.svg" />
    <img
      class="howtpayImage mob"
      src="../../../assets/images/howtopaymob.svg"
    />
  </div>

  <app-flexible *ngIf="parameterValue == 'individual'"></app-flexible>

  <app-trusted></app-trusted>

  <app-numbers *ngIf="parameterValue != 'individual'"></app-numbers>
  <div *ngIf="parameterValue != 'individual'" class="compBg"></div>
  <app-partners></app-partners>

  <div
    *ngIf="parameterValue != 'individual'"
    class="customerComp container comp"
  >
    <div class="sampleImage"></div>
    <div class="customer">
      <div class="customerText">
        <h4>What our customers say about us</h4>
      </div>

      <div class="customeroverlay"></div>
      <swiper
        style="
          --swiper-navigation-color: black;
          --swiper-pagination-color: #fff;
        "
        [navigation]="true"
        [autoplay]="{
          delay: 4000
        }"
        loop="true"
        [breakpoints]="{
          '992': {
            slidesPerView: 2,
            spaceBetween: 10
          },

          '0': {
            slidesPerView: 1,
            spaceBetween: 20
          }
        }"
        class="mySwiper"
      >
        <ng-template swiperSlide>
          <div class="customerCard">
            <img
              class="customerCardImg"
              src="../../../assets/images/quote.svg"
            />
            <p class="cardBody p3">
              "As the Director of New Generation International School it is
              important for me to have a system that is efficient and yet easy
              to use. Klickit is just that. Using the system we manage the
              enrollment of over 3,000 students each term and we are delighted
              with the service."
            </p>
            <div class="bottomCard p2">
              <div>
                <span style="color: #5800bf">- Aly Elbakry</span>
                <br />
                <span class="position">
                  New Generation - International School
                </span>
              </div>

              <img src="../../../assets/images/newgenschool.png" />
            </div>
          </div>
        </ng-template>

        <ng-template swiperSlide>
          <div class="customerCard">
            <img
              class="customerCardImg"
              src="../../../assets/images/quote.svg"
            />
            <p class="cardBody p3">
              “Using Klickit has greatly reduced the administration effort
              involved in taking payments from our parents and it is great to
              have the funds go directly to our bank account. We have no
              hesitation in recommending Klickit to other schools.”
            </p>
            <div class="bottomCard p2">
              <div>
                <span style="color: #5800bf">- Mohamed Hakem</span>
                <br />
                <span class="position"> Heritage International School </span>
              </div>
              <img src="../../../assets/images/heritage.png" />
            </div></div
        ></ng-template>

        <ng-template swiperSlide>
          <div class="customerCard">
            <img
              class="customerCardImg"
              src="../../../assets/images/quote.svg"
            />
            <p class="cardBody p3">
              “We are the first nursery to implement an online payment in Egypt
              and the service offered by klickit is absolutely stunning.”
            </p>
            <div class="bottomCard p2">
              <div>
                <span style="color: #5800bf">- Yasmine ElBehiery</span>
                <br />
                <span class="position"> Leap Development Hub </span>
              </div>
              <img src="../../../assets/images/leap.png" />
            </div></div
        ></ng-template>
      </swiper>
    </div>
  </div>
<div class="comp">
  <app-contactus ></app-contactus>

</div>
</div>
